import { Button, ModuleHeaderSlot } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useWorkTask } from "@tm/context-distribution"
import { channel } from "@tm/models"
import { Toolbar } from "@tm/controls"
import { useHistory } from "react-router-dom"
import { ShellExportButtonComponent as ShellExportButton } from "../../navigation/components/ShellExportButton"
import { useLoadExportInfos } from "./useLoadExportInfos"

type Props = {
    exportTarget?: string
    showExportVoucherButton?: boolean
    showToolbar?: boolean
}
export default function ExportSlot({ exportTarget, showExportVoucherButton, showToolbar }: Props) {
    const { translateText } = useLocalization()
    const { workTaskId } = useWorkTask() ?? {}
    const { exportLabel, exportUri } = useLoadExportInfos(workTaskId, showExportVoucherButton)
    const history = useHistory()
    const buttons = []

    if (exportUri && workTaskId) {
        buttons.push(
            <Button
                onClick={() => {
                    channel("WORKTASK", workTaskId).publish("WORKTASK/CLOSE", undefined)

                    // Even if `window.location.href` is called below, calling `history.push` is needed to close the worktask,
                    // in case the `exportUri` is a custom protocol handler, then the browser may not redirect NEXT to that URL,
                    // but call the URL in the background. (see NEXT-29780)
                    history.push("/")

                    // Don't use `window.open(exportUri!, "internal")` here to call this URL in the hidden iframe,
                    // because browser based DMS require the user to be redirected back to their application.
                    window.location.href = exportUri!
                }}
                key="uri-export"
            >
                {exportLabel || exportTarget || translateText(1875)}
            </Button>
        )
    }

    const shellExportButtonRenders = !!ShellExportButton({})
    if (shellExportButtonRenders) {
        buttons.push(<ShellExportButton key="shell-export" />)
    }

    if (!buttons.length) {
        return null
    }

    return showToolbar ? (
        <Toolbar title={translateText(1209)}>{buttons}</Toolbar>
    ) : (
        <ModuleHeaderSlot title={translateText(1209)}>{buttons}</ModuleHeaderSlot>
    )
}
